module.exports = __webpack_public_path__ + "img/c03_buildingtechbrewing_Normal_ua.6ed198cd.webp";